import { render, staticRenderFns } from "./ReportsOverview.vue?vue&type=template&id=65778993&scoped=true"
import script from "./ReportsOverview.vue?vue&type=script&lang=js"
export * from "./ReportsOverview.vue?vue&type=script&lang=js"
import style0 from "./ReportsOverview.vue?vue&type=style&index=0&id=65778993&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65778993",
  null
  
)

export default component.exports